module.exports = __webpack_public_path__ + "assets/img/empty-green.a8d8674f.svg";